import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import './ABETA.css';
import abetaHero from '../../assets/YOCILAB Webiste photos/Academy Home/ABETA YOCILAB Academy/REMS9766.jpg';
import abetaJourney from '../../assets/YOCILAB Webiste photos/Academy Home/ABETA YOCILAB Academy/23.png';
import abeta2 from '../../assets/YOCILAB Webiste photos/Academy Home/ABETA YOCILAB Academy/0e65f71f-d699-47f7-8f3b-64423de7bb2d.png';
import abeta3 from '../../assets/YOCILAB Webiste photos/Academy Home/ABETA YOCILAB Academy/720e98fe-9c24-4d1e-8b91-b90df79acaeb.png';

const journeySteps = [
  {
    id: 'discover',
    step: '01',
    title: 'DISCOVER',
    subtitle: 'Start with yourself.',
    desc: 'Our AI-powered discovery experience helps you identify your strengths, skills, interests, experience and goals — and turns them into a personalized Builder Profile. Know where you are. See where you could go.',
    cta: 'Discover Your Potential',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>
      </svg>
    ),
  },
  {
    id: 'learn',
    step: '02',
    title: 'LEARN',
    subtitle: 'Start Your Learning Journey.',
    desc: 'Every learner follows a personalized pathway based on their Builder Profile. Choose from live cohort learning or self-paced courses, with AI-powered feedback and mentor support.',
    cta: 'Explore Learning',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
      </svg>
    ),
  },
  {
    id: 'build',
    step: '03',
    title: 'BUILD',
    subtitle: 'Gain real-world experience.',
    desc: 'Builder Studios combine AI-powered collaboration, expert mentorship, and hands-on projects to help you apply what you\'ve learned, solve real problems, and build a portfolio that proves what you can do.',
    cta: 'Explore Builder Studios',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
      </svg>
    ),
  },
  {
    id: 'connect',
    step: '04',
    title: 'CONNECT',
    subtitle: 'Access opportunity.',
    desc: 'The AI opportunity engine watches what you build and matches you to real jobs, ventures, and impact opportunities automatically as you grow. The more you learn, the better your opportunities become.',
    cta: 'Explore Opportunities',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    id: 'passport',
    step: '05',
    title: 'PASSPORT',
    subtitle: 'Carry your proof forward.',
    desc: 'Your Builder Passport is your verified digital portfolio that grows with you. It brings together skills, projects, certifications, ventures, leadership experience, and community impact into one trusted profile.',
    cta: 'Explore Builder Passport',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
        <circle cx="12" cy="10" r="3"/>
        <path d="M7 21v-1a5 5 0 0 1 10 0v1"/>
      </svg>
    ),
  },
];

const studios = [
  {
    title: 'Technology Studio',
    desc: 'Build digital products. Create websites, mobile apps, AI solutions and other digital products while building a portfolio of real technical work.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="3" width="20" height="14" rx="2"/>
        <path d="M8 21h8M12 17v4"/>
      </svg>
    ),
  },
  {
    title: 'Venture Studio',
    desc: 'Build businesses and solutions. Identify problems, validate ideas, understand customers, develop products and build ventures that create economic and social value.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
      </svg>
    ),
  },
  {
    title: 'Career Studio',
    desc: 'Build your career. Create an industry-ready CV, LinkedIn profile and professional portfolio. Practice interviews with an AI Career Coach.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
        <rect x="2" y="7" width="20" height="14" rx="2"/>
        <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
        <line x1="12" y1="12" x2="12" y2="16"/>
        <line x1="10" y1="14" x2="14" y2="14"/>
      </svg>
    ),
  },
];

const tracks = [
  {
    title: 'Digital Intelligence',
    desc: 'Build with technology through AI, prompt engineering, web and mobile development, data, cybersecurity, cloud computing and digital products.',
    color: 'var(--color-academy)',
    bg: 'var(--color-academy-faint)',
  },
  {
    title: 'Enterprise & Impact Intelligence',
    desc: 'Build ideas that create value through customer discovery, social entrepreneurship, product development, business models, financial management, and investment readiness.',
    color: 'var(--color-primary)',
    bg: 'var(--color-primary-faint)',
  },
  {
    title: 'Creative & Human Intelligence',
    desc: 'Build the capabilities that make you stand out through UI/UX, storytelling, digital marketing, design thinking, communication, leadership, and critical thinking.',
    color: 'var(--color-abeta)',
    bg: 'var(--color-abeta-faint)',
  },
];

const ABETA = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach(e => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.08 }
    );
    const targets = sectionRef.current?.querySelectorAll('.fade-up, .slide-left, .slide-right');
    targets?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="abeta-page" ref={sectionRef}>
      <SEO
        title="ABETA — AI-Powered Builders Platform"
        description="ABETA helps young people discover their strengths, develop future-ready skills, build real-world experience, and connect to opportunities. Free to start."
      />

      {/* ─── HERO ─── */}
      <section className="abeta-hero">
        <div className="abeta-hero__bg">
          <img src={abetaHero} alt="ABETA platform" className="abeta-hero__img" />
          <div className="abeta-hero__overlay" />
        </div>
        <div className="container">
          <div className="abeta-hero__badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
            </svg>
            AI-Powered Builders Platform
          </div>
          <h1 className="abeta-hero__title">
            Welcome to <em>ABETA</em>
          </h1>
          <p className="abeta-hero__tagline">
            Discover potential. Build capability. Connect to opportunity — all on one AI-powered platform.
          </p>
        </div>
      </section>

      {/* ─── PROBLEM STATEMENT ─── */}
      <section className="abeta-problem">
        <div className="container">
          <div className="abeta-problem__grid">
            <div className="abeta-problem__visual slide-left">
              <img src={abeta2} alt="Young African talent" className="abeta-problem__img" loading="lazy" />
            </div>
            <div className="abeta-problem__content slide-right">
              <span className="section-label" style={{ color: 'var(--color-abeta)' }}>THE CHALLENGE</span>
              <h2 className="abeta-problem__title">
                Talent is everywhere.<br />Opportunity isn't.
              </h2>
              <p className="abeta-problem__body">
                Across Africa and beyond, millions of young people are learning, creating, building businesses and developing skills. But too much talent remains invisible.
              </p>
              <p className="abeta-problem__body">
                People struggle to know what they are good at, what they should learn next, how to prove what they can do, and where to find opportunities that fit. There is enormous human potential in the world that remains difficult to discover, develop, prove and connect to opportunity.
              </p>
              <div className="abeta-problem__highlight">
                <strong>ABETA</strong> brings together the tools, learning, experience and connections you need to move from potential to capability, capability to proof, and proof to opportunity.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── JOURNEY STEPS ─── */}
      <section className="abeta-journey" id="journey">
        <div className="container">
          <div className="abeta-journey__header fade-up">
            <span className="section-label" style={{ color: 'var(--color-abeta)' }}>START YOUR JOURNEY</span>
            <h2 className="abeta-journey__title">A continuous journey designed around who you are</h2>
            <p className="abeta-journey__desc">
              What you want to become, and what you can build.
            </p>
          </div>

          {/* Journey visual flow */}
          <div className="abeta-journey__flow fade-up" style={{ transitionDelay: '100ms' }}>
            {journeySteps.map((step, i) => (
              <React.Fragment key={step.id}>
                <div className="abeta-journey__flow-step">
                  <div className="abeta-journey__flow-icon">{step.title[0]}</div>
                  <span className="abeta-journey__flow-label">{step.title}</span>
                </div>
                {i < journeySteps.length - 1 && (
                  <div className="abeta-journey__flow-arrow">→</div>
                )}
              </React.Fragment>
            ))}
          </div>

          <div className="abeta-journey__steps">
            {journeySteps.map((step, i) => (
              <div
                key={step.id}
                className="abeta-step-card fade-up"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="abeta-step-card__header">
                  <span className="abeta-step-card__number">{step.step}</span>
                  <div className="abeta-step-card__icon">{step.icon}</div>
                </div>
                <h3 className="abeta-step-card__title">{step.title}</h3>
                <p className="abeta-step-card__subtitle">{step.subtitle}</p>
                <p className="abeta-step-card__desc">{step.desc}</p>
                <a href="#start" className="abeta-step-card__link">
                  {step.cta} →
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── LEARNING TRACKS ─── */}
      <section className="abeta-tracks" id="how-it-works">
        <div className="container">
          <div className="abeta-tracks__header fade-up">
            <span className="section-label" style={{ color: 'var(--color-abeta)' }}>LEARN</span>
            <h2 className="abeta-tracks__title">Three tracks. One purpose.</h2>
            <p className="abeta-tracks__desc">
              Every learner follows a personalized pathway based on their Builder Profile. Choose from live cohort learning or self-paced courses, with AI-powered feedback at every step.
            </p>
          </div>

          <div className="abeta-tracks__grid">
            {tracks.map((t, i) => (
              <div
                key={t.title}
                className="abeta-track-card fade-up"
                style={{ transitionDelay: `${i * 120}ms`, borderTop: `3px solid ${t.color}` }}
              >
                <h3 className="abeta-track-card__title" style={{ color: t.color }}>{t.title}</h3>
                <p className="abeta-track-card__desc">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── BUILDER STUDIOS ─── */}
      <section className="abeta-studios">
        <div className="container">
          <div className="abeta-studios__grid">
            <div className="abeta-studios__content slide-left">
              <span className="section-label" style={{ color: 'var(--color-abeta)' }}>BUILD</span>
              <h2 className="abeta-studios__title">Builder Studios</h2>
              <p className="abeta-studios__body">
                Every Builder Studio combines AI-powered collaboration, expert mentorship, and hands-on projects to help you apply what you've learned, solve real problems, and build a portfolio that proves what you can do.
              </p>
              <div className="abeta-studios__list">
                {studios.map((s) => (
                  <div key={s.title} className="abeta-studio-item">
                    <div className="abeta-studio-item__icon">{s.icon}</div>
                    <div>
                      <h4 className="abeta-studio-item__title">{s.title}</h4>
                      <p className="abeta-studio-item__desc">{s.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
              <a href="#start" className="abeta-studios__btn">
                Explore Builder Studios →
              </a>
            </div>
            <div className="abeta-studios__visual slide-right">
              <img src={abeta3} alt="ABETA Builder Studios" className="abeta-studios__img" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      {/* ─── OPPORTUNITY ENGINE ─── */}
      <section className="abeta-opportunities">
        <div className="container">
          <div className="abeta-opportunities__header fade-up">
            <span className="section-label--white">CONNECT</span>
            <h2 className="abeta-opportunities__title">Unlock Opportunities</h2>
            <p className="abeta-opportunities__desc">
              The AI opportunity engine watches what you build and matches you to real jobs, ventures, and impact opportunities automatically, as you grow. The more you learn and build, the better your opportunities become.
            </p>
          </div>

          <div className="abeta-opportunities__grid">
            {[
              {
                type: 'Career',
                desc: 'Jobs, internships, and freelance work matched to your verified skills.',
                icon: (
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <rect x="2" y="7" width="20" height="14" rx="2"/>
                    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
                    <line x1="12" y1="12" x2="12" y2="16"/>
                    <line x1="10" y1="14" x2="14" y2="14"/>
                  </svg>
                ),
              },
              {
                type: 'Venture',
                desc: 'Investors, mentors, and markets matched to what you\'re building.',
                icon: (
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                    <polyline points="17 6 23 6 23 12"/>
                  </svg>
                ),
              },
              {
                type: 'Impact',
                desc: 'Grants and fellowships matched to the problems you\'re solving.',
                icon: (
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="2" y1="12" x2="22" y2="12"/>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                  </svg>
                ),
              },
            ].map((opp, i) => (
              <div key={opp.type} className="abeta-opp-card fade-up" style={{ transitionDelay: `${i * 120}ms` }}>
                <div className="abeta-opp-card__icon">{opp.icon}</div>
                <h3 className="abeta-opp-card__type">{opp.type}</h3>
                <p className="abeta-opp-card__desc">{opp.desc}</p>
              </div>
            ))}
          </div>

          <div className="abeta-opportunities__passport fade-up">
            <div className="abeta-passport">
              <div className="abeta-passport__content">
                <span className="section-label--white">PASSPORT</span>
                <h3 className="abeta-passport__title">Builder Passport</h3>
                <p className="abeta-passport__subtitle">Your proof of growth.</p>
                <p className="abeta-passport__desc">
                  Your Builder Passport is your verified digital portfolio that grows with you throughout your journey. It brings together your skills, projects, certifications, ventures, leadership experience, and community impact into one trusted profile.
                </p>
                <a href="#start" className="abeta-passport__btn">Explore Builder Passport →</a>
              </div>
              <div className="abeta-passport__visual">
                <img src={abetaJourney} alt="Builder Passport" className="abeta-passport__img" loading="lazy" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ─── FINAL CTA ─── */}
      <section className="abeta-cta" id="start">
        <div className="container">
          <div className="abeta-cta__content fade-up">
            <h2 className="abeta-cta__title">Your potential is already there.</h2>
            <p className="abeta-cta__subtitle">Let's build the proof.</p>
            <p className="abeta-cta__desc">
              Free to start. No CV required — just five minutes and an honest answer.
            </p>
            <p className="abeta-cta__connection">Every step makes the next one stronger.</p>
            <a href="#discover" className="abeta-cta__btn">
              Start Your Journey ↗
            </a>
            <p className="abeta-cta__note">
              Can't pay a program fee right now? <a href="https://chat.whatsapp.com/GoTOvyXjhjk0Nln2LPfsjm" target="_blank" rel="noopener noreferrer">Join the community</a> for free and pay later.
            </p>
            <Link to="/programs/yocilab-academy" className="abeta-cta__link">
              ← Back to YOCILAB Academy
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ABETA;
